import { useEripDeposit } from '@/features/deposit-erip';
import { useOplatiDeposit } from '@/features/deposit-oplati';

type DepositMethod = 'oplati' | 'erip';

interface DepositMethodData {
  accountNumber: string;
  qrCode?: string;
}

interface UseDepositMethodDataReturn {
  data: DepositMethodData | undefined;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
}

export function useDepositMethodData(
  depositMethod: DepositMethod
): UseDepositMethodDataReturn {
  const oplatiQuery = useOplatiDeposit();
  const eripQuery = useEripDeposit();

  const selectedQuery = depositMethod === 'oplati' ? oplatiQuery : eripQuery;

  return {
    data: selectedQuery.data,
    isLoading: selectedQuery.isLoading,
    isError: selectedQuery.isError,
    error: selectedQuery.error,
  };
}
